import React from 'react';
import { motion } from 'framer-motion';
import { dividerQuoteVariant } from '../../animations/animations';

const quotes = [
  { 
    text: "First, solve the problem. Then, write the code.", 
    author: "John Johnson" 
  },
  { 
    text: "Simplicity is the prerequisite for reliability.", 
    author: "Edsger W. Dijkstra" 
  },
  { 
    text: "Code is like humor. When you have to explain it, it's bad.", 
    author: "Cory House" 
  },
  { 
    text: "Perfection is achieved not when there is nothing more to add, but when there is nothing left to take away.", 
    author: "Antoine de Saint-Exupéry" 
  },
];

const Divider = ({ quoteIndex = 0 }) => {
  const quote = quotes[quoteIndex % quotes.length];

  return (
    <div className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Triangle decorations */}
        <div className="flex items-center justify-center gap-4 mb-6" data-aos="fade-down">
          <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-primary opacity-60" />
          <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-primaryLight opacity-80" />
          <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-primary" />
          <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-primaryLight opacity-80" />
          <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-primary opacity-60" />
        </div>

        {/* Quote */}
        <motion.div
          variants={dividerQuoteVariant}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="text-center"
          data-aos="zoom-in"
        >
          <blockquote className="text-xl md:text-2xl text-textSecondary italic font-light">
            "{quote.text}"
          </blockquote>
          <p className="text-textMuted mt-3 text-sm">- {quote.author}</p>
        </motion.div>
      </div>
    </div>
  );
};

export default Divider;
